import * as React from 'react';
import { Table } from 'react-bootstrap';
import { Translate } from '../../../shared/LanguageService';
import { IProduct } from '../Types';
import ProductListRow from './ProductListRow';

interface IProductListProps {
    products: IProduct[];
    editProduct: (id: any) => void;
    viewLogs: (id: any) => void;
    parent: any;
}

const ProductList = (props: IProductListProps) => {
    return (
        <Table responsive>
            <thead>
                <tr>
                    <th>{Translate('products/list/header/name')}</th>
                    <th>{Translate('products/list/header/description')}</th>
                    <th>{Translate('products/list/header/number-of-images')}</th>
                    <th>{Translate('products/list/header/is-discontinued')}</th>
                    <th>{Translate('products/list/header/type')}</th>
                    <th>{Translate('products/list/header/invoice-product-type')}</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                {props.products.map((p: any) => {
                    return (
                        <ProductListRow
                            product={p}
                            key={p.id}
                            onEdit={props.editProduct}
                            onViewLogs={props.viewLogs}
                        />
                    );
                })}
            </tbody>
        </Table>
    );
};

export default ProductList;
